import{extendTailwindMerge,twMerge}from"tailwind-merge";const extendedTWMerge=extendTailwindMerge({prefix:"rui"});/**
 * Merges the provided tailwind classes. This is a wrapper around
 * tailwind-merge's twMerge function to accommodate both the consumer prefix and
 * RUI's prefix.
 *
 * @param classes The classes to merge.
 * @returns The merged classes.
 */export const ruiTWMerge=(...classes)=>{const mergedRUIClasses=extendedTWMerge(...classes);return twMerge(...mergedRUIClasses.split(" "))};